import React from "react";

export default function Card({
    cp,
    date,
    formSchema,
    setCouponDis,
    couponDis,
    setErrMssge,
    setIsError,
    setIsCpnApplied,
    isCpnApplied,
    price,
    setPrice,
    coupon,
    setCoupon,
    userDetails,
    applyCoupon,
    setCoErr,
    setCoErrCode,
}) {
    return (
        <div className="ud-cc-card">
            <div className="ud-co-cont w-row">
                <div className="ud-cc-cont-left w-col w-col-5">
                    <div
                        className="ud-co-code"
                        style={{ width: "90%", wordBreak: "break-all" }}
                    >
                        {cp.code}
                    </div>
                </div>
                <div className="ud-cc-cont-right w-col w-col-7">
                    <div className="ud-cc-div">
                        <div className="ud-cc-offer">{cp.display_text}</div>
                        <div className="ud-cc-valid">*Valid till : {date}</div>
                        <div
                            className="action-btn-2 cc w-button"
                            onClick={(e) => {
                                setCoupon(cp.code);
                                applyCoupon(
                                    formSchema,
                                    setCouponDis,
                                    couponDis,
                                    setErrMssge,
                                    setIsError,
                                    setIsCpnApplied,
                                    isCpnApplied,
                                    price,
                                    setPrice,
                                    cp.code,
                                    setCoupon,
                                    setCoErr,
                                    setCoErrCode
                                );
                            }}
                        >
                            {" "}
                            &nbsp;Apply
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
